import { render, staticRenderFns } from "./editableLabel.vue?vue&type=template&id=611326bb&"
import script from "./editableLabel.vue?vue&type=script&lang=js&"
export * from "./editableLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports